import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import type { FilterDefinition, FilterGroupDefinition } from "../../types/filterDefinition";

/**
 * Discriminates the two registration shapes. `apiCategory` is the discriminant because it is required on a
 * single-key definition and absent from a group by construction — a group's members are predicate-routed.
 */
export const isSingleFilterDefinition = <
    TValues extends IPlainObject,
    TApiCategory extends string,
    TCtx,
    TDataSource extends string,
    TCapability extends string,
>(
    definition:
        | FilterDefinition<TValues, TApiCategory, TCtx, TDataSource, TCapability>
        | FilterGroupDefinition<TValues, TApiCategory, TCtx, TDataSource, TCapability>,
): definition is FilterDefinition<TValues, TApiCategory, TCtx, TDataSource, TCapability> =>
    "apiCategory" in definition;
